module.exports = __webpack_public_path__ + "img/浮生六记.84ec83a7.webp";